!(function () {
  var t = Simba.Functional.nodeList("[data-slider-init]");
  function n(t) {
    (this.configInstance = t),
      (this.config = this.parseConfig(t)),
      (this.hasControls = !1),
      this.init();
  }
  (n.prototype.init = function () {
    (this.instance = new tns(this.config)),
      Object.prototype.hasOwnProperty.call(this.instance, "version") &&
        ((this.container = this.instance.getInfo().container),
        (this.info = this.instance.getInfo),
        (this.slides = this.instance.getInfo().slideItems),
        this.initControls(),
        this.initEvents(),
        this.unhide(),
        this.initCustomPagination());
  }),
    (n.prototype.parseConfig = function (t) {
      return JSON.parse(t.innerHTML);
    }),
    (n.prototype.initEvents = function () {
      var t = this;
      this.hasControls &&
        this.instance.events.on("indexChanged", function () {
          t.setActiveControl();
        });
    }),
    (n.prototype.initControls = function () {
      var t = this,
        n = this.container.getAttribute("data-slider-controls");
      if (null !== n) {
        if (
          ((this.controls = {}),
          (this.hasControls = !0),
          void 0 === (n = document.querySelectorAll(n)))
        )
          return;
        n.forEach(function (n) {
          var i = n.getAttribute("data-index");
          n.addEventListener("click", function () {
            t.instance.goTo(i);
          }),
            (t.controls[i] = n);
        }),
          (this.controls = n),
          this.setActiveControl();
      }
    }),
    (n.prototype.setActiveControl = function () {
      var t = this.instance.getInfo().index,
        n = "data-slider-trigger-active";
      void 0 !== this.activeControl &&
        null !== this.activeControl &&
        this.activeControl.removeAttribute(n),
        void 0 !== this.controls[t] &&
          (this.controls[t].setAttribute(n, !0),
          (this.activeControl = this.controls[t]));
    }),
    (n.prototype.getInstance = function () {
      return this.instance.getInfo().container;
    }),
    (n.prototype.unhide = function () {
      var t = 0;
      for (t = 0; t < this.slides.length; t++)
        this.slides[t].hasAttribute("hidden") &&
          this.slides[t].removeAttribute("hidden");
    }),
    (n.prototype.initCustomPagination = function () {
      var t = this;
      this.config.customNav &&
        (this.customPagination(),
        this.instance.events.on("newBreakpointStart", function () {
          t.customPagination();
        }),
        this.instance.events.on("newBreakpointEnd", function () {
          t.customPagination();
        }),
        this.instance.events.on("indexChanged", function (n) {
          t.setActiveDot(n.index);
        }));
    }),
    (n.prototype.customPagination = function () {
      var t,
        n,
        i,
        e = this.instance.getInfo(),
        o = e.slideCount,
        s = e.items,
        a = e.slideBy,
        r = e.container.parentElement.parentElement.parentElement,
        c = document.createElement("div");
      if (
        (this.customNav && this.customNav.remove(),
        (c.className = "tns-nav"),
        (n = o - (s - a)) > 1)
      ) {
        for (i = 0; i < n; i++)
          (t = document.createElement("button")).setAttribute("data-nav", i),
            this.initDotEvents(t),
            c.appendChild(t);
        r.appendChild(c),
          (this.customNav = c),
          this.setActiveDot(this.instance.getInfo().index);
      }
    }),
    (n.prototype.initDotEvents = function (t) {
      var n = this;
      t.addEventListener("click", function () {
        var i = t.getAttribute("data-nav");
        n.setActiveDot(i), n.instance.goTo(i);
      });
    }),
    (n.prototype.setActiveDot = function (t) {
      var n = "tns-nav-active";
      this.customNav.querySelectorAll("button").forEach(function (t) {
        t.classList.remove(n);
      }),
        this.customNav.querySelector('[data-nav="' + t + '"]').classList.add(n);
    }),
    (Simba._Sliders = t.map(function (t) {
      return new n(t);
    }));
})();
